import { useState, useEffect } from "react";
import { ErrorContext } from "../../../utils/context/error";
import { setuploadvideo } from "../../../services/archivos";
import PropTypes from 'prop-types';
import Modal from "../../modal";

function EditModal({ show, ArchivoI, Tag, handleshow, videoEditar,fillUploadImagen}) 
{
   const [descripcion, setDescripcion]= useState("");
   const [files, setFile]= useState("");
   const [habilita, setHabilita] = useState(false);
   const [validar, setValidar] = useState(false);
   const [ArchivoId, setArchivoId] = useState(0);
   const { setShowToast, setOpciones } = ErrorContext();
   
//-------------------------------------------------------------------------------------------------------------------
   const handleInicio = () =>
    {
//      setDescripcion("");
//      setFile("");
      setArchivoId(ArchivoI)
      console.log("en el interior::", videoEditar)
    }
   
//-------------------------------------------------------------------------------------------------------------------
   const handleAceptar = async() =>
    {
      setHabilita(true);
      setShowToast(false);
      const response = await setuploadvideo(  
          files,
          descripcion,
          ArchivoId,
          Tag,
          'VI'
        );
        if (response) 
          {
            if (response.status === 200) 
              {
                handleshow(false);
                fillUploadImagen();
              } 
            else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
            }
          }
        else
          {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
          }  
        setHabilita(false);
    }
   
   //----------------------------------------------------
   const handleCancel = () =>
    {
      handleshow(false);
    }
  //-----------------------------------------------------
  const handleFileSelected = (file) => 
    {
      setFile(file);
    };  
  
  //-----------------------------------------------------
  useEffect(() => 
    {
     if (show)
      console.log(videoEditar)
      handleInicio()
    }, [show]);
    
    return (
        <>
         <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Editar Archivo'}>
            <div className="flex lg:w-[26rem]">
                <form noValidate className="flex flex-col w-full">
                    <div className="flex flex-col w-full h-full ">
                      <div className="w-full">
                         <div className="flex flex-col gap-4 p-1 w-full">
                              <div className="flex w-full justify-center rounded-md bg-black">
                                <video
                                  key={videoEditar.Ruta}
                                  src={videoEditar.Ruta}
                                  controls
                                  className="max-h-[12rem] w-full object-contain"
                                >
                                  Tu navegador no soporta la reproducción de video.
                                </video>
                              </div>
                          </div>
                        </div>      
                      <div className="w-full mt-4">
                         <label>Descripción</label>
                          <textarea name='searchid' value={descripcion || ""} placeholder="Descripción" 
                                    onChange={(e)=> setDescripcion(e.target.value)}
                                    autoComplete="off" 
                                    disabled={Tag === 2}>
                            </textarea>
                      </div>
                      
                      <div className="flex w-full gap-4 mt-6 justify-end">
                         <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                         <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                      </div>
                    </div>  
                </form>
            </div>           
         </Modal>              
        </>
      );
}

EditModal.propTypes = {
  show: PropTypes.bool.isRequired,
  ArchivoI: PropTypes.number.isRequired, 
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  videoEditar: PropTypes.object.isRequired,
  fillUploadImagen: PropTypes.func.isRequired,
};

export default EditModal;